import { gsap } from "gsap";
import { scrollToYPos } from "../helpers/scrollHelpers";

const navOverlay = () => {
	// Open nav
	const openSelectors = document.querySelectorAll('.js-open-nav');
	openSelectors.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();
			document.body.classList.add('no-scroll');
			scrollToYPos(window.scrollY + 1, 0);
			openNav();
		});
	});

	// Close nav
	const closeSelectors = document.querySelectorAll('.js-close-nav');
	closeSelectors.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();

			document.body.classList.remove('no-scroll');
			closeNav();
		});
	});

	// Hover effect
	const navLinks = document.querySelectorAll('.c-nav-overlay #menu-main-menu a');
	navLinks.forEach((link) => {
		link.addEventListener('mouseenter', (e) => {
			link.classList.add('is-hovered');
			document.querySelector('.c-nav-overlay #menu-main-menu').classList.add('is-faded');
		});
		link.addEventListener('mouseleave', (e) => {
			link.classList.remove('is-hovered');
			document.querySelector('.c-nav-overlay #menu-main-menu').classList.remove('is-faded');
		});
	});
};

function openNav() {
	const nav = document.querySelector('.c-nav-overlay');
	const navBg = document.querySelector('.c-nav-overlay__bg');
	const navMain = document.querySelector('.c-nav-overlay__main');
	const navMenuItems = document.querySelectorAll('.c-nav-overlay__nav a');
	const navHeaderItems = document.querySelectorAll('.js-nav-header-item');
	const navFooter = document.querySelector('.c-nav-overlay__footer');

	const navOpenTl = gsap.timeline();
	navOpenTl.addLabel('start', 0);
	navOpenTl.addLabel('afterFadeIn', 1);
	navOpenTl.addLabel('afterNavAnimated', 1.35);

	// Fade in background
	navOpenTl.to(navBg, {
		opacity: 1,
		duration: 1.3,
		ease: 'linear',
	}, 'start');

	// Slide down beige background
	navOpenTl.to(navMain, {
		y: 0,
		duration: 1.3,
		ease: 'expo.inOut'
	}, 'start');

	// Animate in main nav items
	navOpenTl.staggerTo(navMenuItems, 0.5, {
		y: 0,
	}, 0.025, 'afterFadeIn');

	// Animate in header
	navOpenTl.staggerTo(navHeaderItems, 0.4, {
		opacity: 1,
		ease: 'power2.ease',
	}, 0.04, 'afterNavAnimated');

	// Slide up footer
	navOpenTl.to(navFooter, {
		y: 0,
		duration: 0.5,
		delay: 0.2,
		ease: 'power3.ease',
	}, 'afterNavAnimated');
}

function closeNav() {
	const nav = document.querySelector('.c-nav-overlay');
	const navBg = document.querySelector('.c-nav-overlay__bg');
	const navMain = document.querySelector('.c-nav-overlay__main');
	const navMenuItems = document.querySelectorAll('.c-nav-overlay__nav a');
	const navHeaderItems = document.querySelectorAll('.js-nav-header-item');
	const navFooter = document.querySelector('.c-nav-overlay__footer');

	const navCloseTl = gsap.timeline();
	navCloseTl.addLabel('start', 0);
	navCloseTl.addLabel('afterHeaderFooter', 0.25);
	navCloseTl.addLabel('afterNavItems', 0.5);
	
	// Slide down footer
	navCloseTl.to(navFooter, {
		y: '100%',
		duration: 0.4,
		ease: 'power3.ease',
	}, 'start');

	// Animate out header
	navCloseTl.to(navHeaderItems, {
		opacity: 0,
		duration: 0.4,
		ease: 'power2.ease',
	}, 'start');

	// Animate out nav items
	navCloseTl.staggerTo(navMenuItems, 0.5, {
		y: '105%',
		from: 'end',
	}, -0.02, 'afterHeaderFooter'); // Negative stagger interval makes it start with last item

	// Slide up main background
	navCloseTl.to(navMain, {
		y: '-100%',
		duration: 1.3,
		ease: 'expo.inOut',
	}, 'afterNavItems');

	// Fade out nav bg
	navCloseTl.to(navBg, {
		opacity: 0,
		duration: 1.3,
		ease: 'linear',
	}, 'afterNavItems');
}

navOverlay();

export {openNav, closeNav};